import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import RailTrackAutocomplete from '@planning/pages/Order/components/RailTrackAutocomplete'
import { useTranslate } from '@tolgee/react'
import { computed } from 'mobx'
import { FC, useCallback, useState } from 'react'
import { RailcarPlanningViewStore } from '../../Stores/RailcarPlanningViewStore'

type Props = {
  railcarPlanningViewStore: RailcarPlanningViewStore
  railVisitId: number
  railcarTrackPositionId: number
  open: boolean
  onClose: () => void
}

export const RailcarPlanningChangeRailtrackDialog: FC<Props> = props => {
  const { open, railcarPlanningViewStore, railVisitId, railcarTrackPositionId, onClose } = props
  const { t } = useTranslate()
  const { railcarTrackPositionItemStore, railVisitItemStore } = usePlanningStore()

  const [railtrack, setRailtrack] = useState<string | undefined>()

  const railTracks = computed(() => {
    const allTracks = railcarTrackPositionItemStore.getRailTracks()
    const assignedIds =
      railVisitItemStore.getById(railcarPlanningViewStore.railVisitItem.id)?.data
        .assignedRailTrackIds || []
    return allTracks.filter(track => assignedIds.includes(track.id))
  }).get()

  const closeModal = useCallback(() => {
    setRailtrack(undefined)
    onClose()
  }, [onClose])

  const onChange = useCallback(() => {
    if (!railtrack) return
    railcarPlanningViewStore.updateRailtrack(railVisitId, railtrack, railcarTrackPositionId)
    closeModal()
  }, [railtrack, railcarPlanningViewStore, railVisitId, railcarTrackPositionId, closeModal])

  const onCancel = useCallback(() => closeModal(), [closeModal])

  return (
    <Dialog open={open} fullWidth maxWidth='xs'>
      <DialogTitle>{t('changeRailtrack', 'Change rail track')}</DialogTitle>
      <DialogContent sx={{ overflow: 'visible' }}>
        <Stack spacing={2} pt={1}>
          <RailTrackAutocomplete
            value={railtrack}
            required
            onChange={val => setRailtrack(val)}
            label={t('railTrack', 'Rail track')}
            options={railTracks}
            hasError={false}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onChange} variant='contained' color='primary'>
          {t('change', 'Change')}
        </Button>
        <Button onClick={onCancel} color='inherit'>
          {t('cancel', 'Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
